export const OrDivider = () => {
  return (
    <div className="my-5 flex items-center gap-3">
      <span className="h-px flex-1 bg-gray-200 dark:bg-gray-600" />
      <span className="text-sm text-gray-400">или</span>
      <span className="h-px flex-1 bg-gray-200 dark:bg-gray-600" />
    </div>
  )
}
